import { render, staticRenderFns } from "./createConsultant.vue?vue&type=template&id=11cfc0a6&scoped=true&"
import script from "./createConsultant.vue?vue&type=script&lang=js&"
export * from "./createConsultant.vue?vue&type=script&lang=js&"
import style0 from "./createConsultant.vue?vue&type=style&index=0&id=11cfc0a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cfc0a6",
  null
  
)

export default component.exports